export default "__VITE_ASSET__CatfZsaO__"